import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VDialog,
    {
      attrs: { persistent: "", "max-width": "370" },
      model: {
        value: _vm.dialogVisible,
        callback: function ($$v) {
          _vm.dialogVisible = $$v
        },
        expression: "dialogVisible",
      },
    },
    [
      _c(
        VCard,
        [
          _c(VCardTitle, { staticClass: "headline" }),
          _c(VCardText, [_vm._v(_vm._s(_vm.descricao))]),
          _c(
            VCardActions,
            [
              _c(VSpacer),
              _c(
                VBtn,
                {
                  attrs: { text: "", color: "error" },
                  on: {
                    click: function ($event) {
                      return _vm.confirmAction()
                    },
                  },
                },
                [_vm._v(" [E] Excluir ")]
              ),
              _c(
                VBtn,
                {
                  attrs: { text: "", color: "grey" },
                  on: {
                    click: function ($event) {
                      return _vm.toogleVisible()
                    },
                  },
                },
                [_vm._v(" [C] Cancelar ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }